module.exports = __webpack_public_path__ + "media/images/Virtual_Studio_Banner-a492c302.jpg";